import { MaterialIcon, GraviButton } from '@gravitate-js/excalibrr'
import { Popover } from 'antd'
import type React from 'react'

interface AddCustomerNoteButtonProps {
  isNotePopoverVisible: boolean
  setIsNotePopoverVisible: (visible: boolean) => void
  notePopoverContent: React.ReactNode
}

export function AddCustomerNoteButton({
  isNotePopoverVisible,
  setIsNotePopoverVisible,
  notePopoverContent,
}: AddCustomerNoteButtonProps) {
  return (
    <Popover
      content={notePopoverContent}
      title='Add Customer Note'
      trigger='click'
      open={isNotePopoverVisible}
      onOpenChange={setIsNotePopoverVisible}
    >
      <GraviButton
        style={{ fontWeight: 'bold' }}
        buttonText='Customer Note'
        icon={<MaterialIcon icon='add' className='pt-1' />}
      />
    </Popover>
  )
}
